import { useEffect, useState } from 'react';
import { useGlobalStore } from '../../stores/global-store';

// Controller for the app loading screen. The screen itself is the static
// #app-preloader in index.html — a single element (warm gradient backdrop,
// Songhunt wordmark, CSS equalizer matching the Lottie loader) that paints
// before any JavaScript downloads and stays up, unchanged, until the data
// bootstrap completes. This component only decides WHEN it goes away: fade it
// out once globalStore.initialLoadingProcessComplete is set (user, filters,
// curated playlists all loaded), with a safety cap so it can never
// stick if the bootstrap dies (e.g. offline).
//
// Deliberately renders nothing: an earlier version rendered a React overlay
// (the Lottie equalizer) that took over from the static preloader — but two
// separately-rendered trees can never be guaranteed pixel-identical, and the
// handoff produced a visible micro-shift. One element, no handoff.
const FADE_MS = 500;
const SAFETY_CAP_MS = 8000;

export default function AppLoader() {
  const initialLoadingComplete = useGlobalStore(s => s.initialLoadingProcessComplete);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const safety = window.setTimeout(() => setDone(true), SAFETY_CAP_MS);
    return () => clearTimeout(safety);
  }, []);

  useEffect(() => {
    if (initialLoadingComplete) {
      setDone(true);
    }
  }, [initialLoadingComplete]);

  useEffect(() => {
    if (!done) {
      return;
    }
    const el = document.getElementById('app-preloader');
    if (!el) {
      return;
    }
    el.style.transition = `opacity ${FADE_MS}ms ease`;
    el.style.opacity = '0';
    el.style.pointerEvents = 'none';
    const t = window.setTimeout(() => el.remove(), FADE_MS);
    return () => clearTimeout(t);
  }, [done]);

  return null;
}
